// Import: Middleware Action & Custom Types
import {
  CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL,
  CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR,
} from '_models/redux/types';

// Action function
export const cleanUpdateOrderLineAssignment = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_UPDATE_ASSIGMENTS_ORDER_DETAIL_ERROR,
    });
  }
};
